export default "/template/resource//static/media/img_notice.c68662ef.png";